import { jwtDecode } from 'jwt-decode'

import { dispatchFeedbackToast } from '~/components/feedback'
import { JWTPayload, history, setLocalstorage } from '~/helpers'
import localstorageConstants, {
  getParsedLocalstorage,
  removeLocalstorage
} from '~/helpers/localstorage-manipulation'
import { getUserAccounts } from '~/modules/users/store/actions'
import { signin } from '~/services/signin-service'
import store from '~/store'
import { getAccessModules } from '~/store/modules/accessModules/actions'
import { getAccountInfo } from '~/store/modules/account/actions'

import * as types from './constants'

/**
 * O fallback de moeda pertence à conta que o buscou. Toda sessão nova passa por
 * aqui — inclusive a troca de conta — então é o ponto certo para descartá-lo,
 * qualquer que tenha sido o caminho de saída da sessão anterior.
 */
const dropCurrencyFallbackAppInfo = () => {
  const appInfo = getParsedLocalstorage(localstorageConstants.APP_INFO)

  if (appInfo?.isCurrencyFallback) {
    removeLocalstorage(localstorageConstants.APP_INFO)
  }
}

/**
 * @param token
 * @param callback_url URL que devemos redirecionar após o login
 * @param origin  Chave que armazena origem do login
 *
 * Refatorar para usar spread
 */

// `indent` conflita com a formatação do prettier nesta arrow curried.
/* eslint-disable indent */
export const setLoggedIn =
  (token, callback_url, origin = 'newtail') =>
  dispatch => {
    // Valida o token: lança e aborta o login se vier malformado.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const decodeToken = jwtDecode<JWTPayload>(token)

    setLocalstorage(localstorageConstants.TOKEN, token)

    setLocalstorage(localstorageConstants.ORIGIN, origin)

    localStorage.removeItem(localstorageConstants.ACCOUNT_INFO)
    localStorage.removeItem(localstorageConstants.REDUX_PERSIST)

    dropCurrencyFallbackAppInfo()

    dispatch(getAccessModules())

    dispatch(getAccountInfo(callback_url))

    dispatch(getUserAccounts())
  }
/* eslint-enable indent */

export const setExternalLoggedIn = props => dispatch => {
  const { token, callback_url, origin = 'newtail' } = props

  const decodeToken = jwtDecode<JWTPayload>(token)

  dispatch({
    type: `${types.LOGIN_REQUEST}_FULFILLED`,
    payload: decodeToken
  })

  setLocalstorage(localstorageConstants.TOKEN, token)

  setLocalstorage(localstorageConstants.ORIGIN, origin)

  localStorage.removeItem(localstorageConstants.ACCOUNT_INFO)
  localStorage.removeItem(localstorageConstants.REDUX_PERSIST)

  dropCurrencyFallbackAppInfo()

  dispatch(getAccessModules())

  dispatch(getAccountInfo(callback_url))

  dispatch(getUserAccounts())
}

export const signIn = ({ email, password }, callback_url = null) => {
  const { dispatch } = store

  dispatch({
    type: types.LOGIN_REQUEST,
    payload: signin(email, password),
    onSuccess: resp => {
      const decodeToken = jwtDecode<JWTPayload>(resp.data.token)

      if (!decodeToken.current_account_id) {
        dispatchFeedbackToast({
          type: 'critical',
          message: 'Usuário sem conta associada!'
        })
        throw new Error()
      }

      const token = resp.data.token

      dispatch(setLoggedIn(token, callback_url))
    },
    hideError: true,
    getErrorFeedbackMsg: error => error.response.data.error.message
  })
}

export const signOut = () => dispatch => {
  const origin = localStorage.getItem(localstorageConstants.ORIGIN)
  const appInfo = getParsedLocalstorage(localstorageConstants.APP_INFO)

  // Via helper, para notificar quem observa a sessão.
  removeLocalstorage(localstorageConstants.TOKEN)

  dropCurrencyFallbackAppInfo()

  localStorage.removeItem(localstorageConstants.ORIGIN)
  localStorage.removeItem(localstorageConstants.ACCOUNT_INFO)
  localStorage.removeItem(localstorageConstants.REDUX_PERSIST)
  localStorage.removeItem(localstorageConstants.SUPER_ADMIN)

  // caches?.keys().then(names => {
  //   names.forEach(name => {
  //     caches.delete(name)
  //   })
  // })

  dispatch({ type: types.LOGIN_LOGGED_OUT })

  if (origin === 'marketplace' && appInfo?.callbackLogoutUrl) {
    history.push(appInfo?.callbackLogoutUrl)
  } else {
    history.push('/login')
  }
}

export const setAccountId = accountId => dispatch =>
  dispatch({ type: types.LOGIN_SET_ACCOUNT_ID, payload: accountId })
